interface TrackEventOptions<TEventHandler extends (...args: any) => any> {
  eventType: string;
  // this is because in some cases the event to report will need some dynamic data only present when the event happens, e.g.: a form submit
  getEventProperties?: (
    ...args: Parameters<TEventHandler>
  ) => Record<string, any>;
}

export function trackAmplitudeEvent<
  TEventHandler extends (...args: any) => any
>(eventHandler: TEventHandler, options: TrackEventOptions<TEventHandler>) {
  return (...args: Parameters<TEventHandler>) => {
    const eventProperties = options?.getEventProperties
      ? options.getEventProperties(...args)
      : {};
    window.amplitude.getInstance().logEvent(options.eventType, eventProperties);
    eventHandler(...args);
  };
}
